import { useMemo } from "react";

import { useEventDefs } from "@/api/useEventDefs";
import { isDestinationEnabledForEvent } from "@/LibraryPageV2/utils";
import { LoadedDestinationInfo, LoadedEventDefinition } from "@/types/global";
import { EnableDestinationContext, EnableDestinationData } from "./types";

export function isEventSelected(
  event: LoadedEventDefinition,
  destination: LoadedDestinationInfo,
  data: Pick<EnableDestinationData, "destinationSlug" | "eventToggles">,
): boolean {
  if (event.id in data.eventToggles) {
    return data.eventToggles[event.id];
  }
  return !!isDestinationEnabledForEvent(
    destination,
    data.destinationSlug ?? "",
    event,
  );
}

/** Event definitions that will be sent to the wizard's destination. */
export function useEventsForDestination(
  data: EnableDestinationData,
  context: EnableDestinationContext,
): LoadedEventDefinition[] {
  const { data: eventDefs } = useEventDefs();
  const { configuredDestination } = context;

  return useMemo(() => {
    if (!configuredDestination || !data.destinationSlug) {
      return [];
    }
    return (eventDefs ?? []).filter(
      (event) =>
        !event.deleted_at &&
        isEventSelected(event, configuredDestination, data),
    );
  }, [configuredDestination, data, eventDefs]);
}
